import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import ClickableElement from '../ClickableElement';

export const IconButton = ({ className, onClick, name, size, fill }) => (
  <ClickableElement onClick={onClick} className={className} styleName="link">
    <Icon name={name} size={size} style={{ fill }} />
  </ClickableElement>
);

IconButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  name: PropTypes.string,
  size: PropTypes.number,
  fill: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Button/IconButton.jsx